window.GADimensions = window.GADimensions || {}; // make sure it exists to prevent unit tests from crashing

let loggingEnabled = window.appConfig?.gaLoggingEnabled || false;

export type GaCategory = (typeof categories)[keyof typeof categories];

export const categories = {
    //Category strings.
    // Be careful modifying these as it will mess up historical GA events
    ASYNC_JOB: 'AsyncJob',
    CUSTOM_FORMS: 'Client Forms',
    CUSTOM_FORMS_BUILDER: 'Form builder',
    CLIENT_PHOTO: 'Client photo',
    INSTAGRAM_INTEGRATION: 'Instagram Integration',
    REPEAT_APPOINTMENTS: 'Repeat appointments',
    DEPOSIT_SETTINGS: 'Online Booking Deposit settings',
    DEPOSITS: 'In-salon Deposits',
    VOUCHER_SETTINGS: 'Online Voucher Sales settings',
    PAYMENT_GATEWAYS: 'Payment gateways',
    SETTINGS: 'Settings',
    CLIENTS: 'Clients',
    CLIENT_CARD_HISTORY: 'Client card history',
    TIMESHEETS: 'Time Sheets',
    APPOINTMENT_BOOK: 'Appointment book',
    INVOICING: 'Invoicing',
    REFUNDS: 'Refunds',
    STAFF_AND_USERS: 'Staff & Users',
    VOUCHERS: 'Vouchers',
    GIVE_TO_CLIENT: 'Give-to-client',
    WAITLIST: 'Waitlist',
    VOUCHER: 'Voucher',
    SMART_OB_DEPOSITS: 'Smart OB Deposits',
    SMART_OB_CANCELLATION_FEE: 'Smart OB Cancellation fee',
    MESSAGES: 'Messages',
    INBOX: 'Inbox',
    REMINDER_SETTINGS: 'Reminder settings',
    SALES: 'Sales',
    BUSINESS_LEAVE: 'Business leave',
    ROOMS_AND_EQUIPMENT: 'Rooms & Equipment',
    TIMETABLES: 'Timetables',
    SECURITY_LOG: 'Security Log',
    PRODUCTS: 'Products',
    STOCKTAKE: 'Stocktake',
    CONCESSION: 'Concession',
    CANCELLATION_FEE: 'Cancellation fee',
    CARDLESS_CHECKOUT: 'Cardless checkout',
    PIN_ACCESS: 'PIN Access',
    VERIFY_CLIENT: 'Verify client details',
    PAY_BY_LINK: 'Payment link',
    GENERAL: 'General',
} as const;

export function trackPageView(trackEvent: string) {
    if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
            page_path: '/k1/' + trackEvent,
        });
        if (loggingEnabled) {
            console.log('track PageView: ' + Array.from(arguments).join(' | '));
        }
    }
}

/**
 * @param eventCategory - Typically the area ok k1 being interacted with, hopefully using a constant from the top of this class.
 * @param eventAction - The type of interaction, or what the user is doing, for example: "Clicked resend failed connections".
 * @param [eventLabel] - Useful for categorizing events, for example we use this field to distinguish events for different k1 report types.
 * @param [eventValue] - A numeric value associated with the event
 *
 * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 */
export function trackEvent(
    eventCategory: GaCategory,
    eventAction: string,
    eventLabel?: string,
    eventValue?: number
) {
    if (typeof window.gtag === 'function') {
        window.gtag('event', 'general', {
            event_category: eventCategory,
            event_action: eventAction,
            event_label: eventLabel,
            value: eventValue,
        });
        if (loggingEnabled) {
            console.log('track Event: ' + Array.from(arguments).join(' | '));
        }
    }
}

export function trackDimension(dimension: string, dimensionValue: string) {
    if (typeof window.gtag === 'function') {
        window.gtag('set', dimension, dimensionValue);
        if (loggingEnabled) {
            console.log('track Dimension: ' + Array.from(arguments).join(' | '));
        }
    }
}

export function getGawInvoiceCategory(isRefund: boolean): GaCategory {
    return isRefund ? categories.REFUNDS : categories.INVOICING;
}

export default {
    ...categories,
    getGawInvoiceCategory,
    trackDimension,
    trackEvent,
    trackPageView,
};

/**
 * Enable/disable GA javascript debug event/pageview logging
 *
 * @param isEnabled
 */
// @ts-expect-error TS(2339): Property 'setGaLogging' does not exist on type 'Wi... Remove this comment to see the full error message
window.setGaLogging = (isEnabled: any) => {
    loggingEnabled = isEnabled;
};
